<div class="content-wrapper_margin">
  <div class="container">
    <div class="error-page">
      <img src="./assets/img/404.svg" alt="{{'CORE.404.title' | translate}}">
      <h1>{{'CORE.404.title' | translate}}</h1>
      <p>{{'CORE.404.msg' | translate}}<a href="/">{{'CORE.404.mp' | translate}}</a></p>
    </div>
  </div>
</div>
